import {
  ActivatedRouteSnapshot,
  DetachedRouteHandle,
  RouteReuseStrategy
} from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable()
export class LMRouteReuseStrategy extends RouteReuseStrategy {
  /**
   * Determines if this route (and its subtree) should be detached to be reused later
   */
  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  /**
   * Stores the detached route
   */
  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
  }

  /**
   * Determines if this route (and its subtree) should be reattached
   */
  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  /**
   * Retrieves the previously stored route
   */
  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle {
    return null;
  }

  /**
   * Determines if a route should be reused
   */
  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    return false;
    // return future.routeConfig === curr.routeConfig;

    // tslint:disable
    // See this link for a custom reuse strategy that takes the url into account and not just the route specification
    // https://github.com/manfredsteyer/angular-2-reuse-strategy-sample/blob/6ac43c7e96cd507dd8dcc4a7a89b760aba6c1844/app/shared/router/custom-reuse-strategy.ts
    // tslint:enable
  }
}
